import React, { useEffect, useRef, useState } from "react";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  Button,
  Icon,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useHistory, useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import ReactToPrint from 'react-to-print';
import { useRecoilState, } from 'recoil';
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import RSelect from "../../components/select/ReactSelect";
import { GET } from "../../helper/api";
import { getToken } from "../../helper/auth";
import { popupPNCustomerFlowAtom, popupPNTransactionHistoryAtom } from '../../state';
import { transactionHistoryColTable } from "../../utils/col-table";
import { MONEY_TYPE, PN_CATEGORY_GROUP } from "../../utils/Utils";

const MONEY_TYPE_OPTIONS = Object.keys(MONEY_TYPE).map((c) => ({
  label: MONEY_TYPE[c],
  value: c,
}));

const PNTransactionHistoryBankAccountManager = () => {
  const history = useHistory();
  const printRef = useRef();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState([]);
  const { bankAccountId } = useParams();

  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [summary, setSummary] = useState({});
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [bankAccountInfo, setBankAccountInfo] = useState({});

  const [popupPNTransactionHistory] = useRecoilState(popupPNTransactionHistoryAtom);
  const [popupPNCustomerFlow] = useRecoilState(popupPNCustomerFlowAtom);

  const [filter, setFilter] = useState({
    debtUserId: searchParams.get('debtUserId') || undefined,
    customerId: searchParams.get('customerId') || undefined,
    categoryId: searchParams.get('categoryId') || undefined,
    type: searchParams.get('type') || undefined,
  });

  const [rangeDate, setRangeDate] = useState({
    fromDate: searchParams.get('fromDate') ? moment(searchParams.get('fromDate')).startOf('days').toDate() : moment().startOf('days').toDate(),
    toDate: searchParams.get('toDate') ? moment(searchParams.get('toDate')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const [updatedAt, setUpdatedAt] = useState();

  const colTable = transactionHistoryColTable();

  useEffect(() => {
    GET(`/pn-customer`, {
    }, true)
      .then(({ data }) => {
        setCustomerOptions(data.map(c => ({
          label: c.name,
          value: c.id,
          data: c
        })))
      })

    GET(`/pn-category`, {}, true)
      .then(({ data }) => {
        setCategoryOptions(data.map(c => ({
          label: `${c.name} (${PN_CATEGORY_GROUP[c.group]})`,
          value: c.id,
          data: c
        })))
      })


    GET("/user", {
    }, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });


    GET(`/pn-bank-account/${bankAccountId}`, {}, true)
      .then(({ data }) => setBankAccountInfo(data))
  }, []);


  useEffect(() => {
    setLoading(true);
    setData([]);

    const newParams = new URLSearchParams({
      fromDate: moment(rangeDate.fromDate).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.toDate).format("YYYY-MM-DD"),
      ...(filter.debtUserId ? { debtUserId: filter.debtUserId } : {}),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.group ? { group: filter.group } : {}),
      ...(filter.categoryId ? { categoryId: filter.categoryId } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    let params = {
      bankAccountId,
      fromDate: moment(rangeDate.fromDate).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.toDate).format("YYYY-MM-DD"),
      ...(filter.debtUserId ? { debtUserId: filter.debtUserId } : {}),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.categoryId ? { categoryId: filter.categoryId } : {}),
    };

    GET(`/pn-transaction-history`, params, true)
      .then(({ data }) => {
        setData([...data?.rows]);
        setSummary({
          ...data.summary,
          count: data.count,
        });

      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    filter,
    updatedAt,
    popupPNTransactionHistory.updatedAt,
    popupPNCustomerFlow.updatedAt
  ]);

  // toggle function to view order details

  const onRangeChange = (dates) => {
    const [fromDate, toDate] = dates;
    setRangeDate({
      fromDate: fromDate ? moment(fromDate)?.startOf('days').toDate() : fromDate,
      toDate: toDate ? moment(toDate)?.endOf('days').toDate() : toDate
    });
    if (fromDate && toDate) {
      setUpdatedAt(moment().valueOf());
    }
  };


  const exportExcel = () => {
    const params = new URLSearchParams({
      fromDate: moment(rangeDate.fromDate).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.toDate).format("YYYY-MM-DD"),
      ...(filter.debtUserId ? { debtUserId: filter.debtUserId } : {}),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.categoryId ? { categoryId: filter.categoryId } : {}),
      bankAccountId,
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/pn-transaction-history/by-account-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Quản lý giao dịch"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.fromDate}
                          startDate={rangeDate.fromDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.toDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Tìm kiếm NV"
                          classNamePrefix="form-control"
                          options={userOptions}
                          value={userOptions.find(
                            (c) => c.value === filter.debtUserId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              debtUserId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Tìm kiếm KH/NCC"
                          classNamePrefix="form-control"
                          options={customerOptions}
                          value={customerOptions.find(
                            (c) => c.value === filter.customerId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              customerId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Tìm kiếm Danh mục"
                          classNamePrefix="form-control"
                          options={categoryOptions}
                          value={categoryOptions.find(
                            (c) => c.value === filter.categoryId
                          ) || null}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              categoryId: (val && val.value) || null,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Tìm kiếm Loại"
                          classNamePrefix="form-control"
                          options={MONEY_TYPE_OPTIONS}
                          value={MONEY_TYPE_OPTIONS.find(
                            (c) => c.value === filter.type
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              type: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap">
                        <ReactToPrint
                          trigger={() => <Button className={'btn-secondary'}>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="ml-3 btn-secondary">
                          Xuất excel
                        </Button>
                        <Button
                          className="ml-3 btn-secondary"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <span>Trở về</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        >
                          {/* <label>
                            <span className="d-none d-sm-inline-block">Show</span>
                            <Input type="month" />
                          </label> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3" ref={printRef}>
                  <h5 className="text-center">Sổ Quỹ (Tài khoản(đ): {bankAccountInfo?.name} <NumericFormat
                    displayType={"text"}
                    value={bankAccountInfo?.amount || 0}
                    thousandsGroupStyle="thousand"
                    thousandSeparator=","
                    decimalScale={2}
                    className="h4"
                  />)</h5>
                  <h6 className="text-center">Từ ngày {moment(rangeDate.start).format('DD-MM-YYYY')} đến {moment(rangeDate.end).format('DD-MM-YYYY')}</h6>

                  <Table
                    notShowPagi={true}
                    loading={loading}
                    columns={colTable}
                    data={data}
                    headerRow={<>
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td></td>
                        <td></td>
                        <td colSpan={2}>
                          Số dư đầu kỳ
                        </td>
                        <td></td>
                        <td></td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.firstAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td></td>
                        <td></td>

                      </tr>
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td></td>
                        <td></td>
                        <td colSpan={2}>
                          Tổng phát sinh
                        </td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.totalAmountIn || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.totalAmountOut || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.totalAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />

                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td></td>
                        <td></td>
                        <td colSpan={2}>
                          Số dư cuối kỳ
                        </td>
                        <td></td>
                        <td></td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.lastAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td></td>
                        <td></td>

                      </tr>
                    </>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default PNTransactionHistoryBankAccountManager;
